import { render, staticRenderFns } from "./BoxAlertSettings.vue?vue&type=template&id=0875d0d2&"
import script from "./BoxAlertSettings.vue?vue&type=script&lang=js&"
export * from "./BoxAlertSettings.vue?vue&type=script&lang=js&"
import style0 from "./BoxAlertSettings.vue?vue&type=style&index=0&id=0875d0d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QTooltip,QInput,QBtnDropdown,QOptionGroup,QSelect,QBtn,QToggle,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon,QTooltip,QInput,QBtnDropdown,QOptionGroup,QSelect,QBtn,QToggle,QInnerLoading,QSpinnerTail})
